import {
  SecondaryLoadingButton,
} from 'components';
import { UploadIcon } from 'assets/icons';
import {
  Typography,
} from '@mui/material';
import StreamingPlayer from 'components/organisms/streaming-player';

interface VideoInputProps {
  handleInputClick: () => void
  videoLoading: boolean,
  label: string,
  videoFileInputRef: any
  handleVideo: (event: any) => {}
  buttonLabel: string,
  url: string,
  onRemove: () => void
}

const VideoInput = ({
  handleInputClick, videoFileInputRef, label, buttonLabel, handleVideo, videoLoading, url, onRemove,
}: VideoInputProps) => (
  <div>
    <Typography variant="body1">{label}</Typography>
    <div style={{ marginTop: '5px' }}>
      {url && (
        <StreamingPlayer
          src={url}
          openInModal
          onRemove={onRemove}
          sx={{
            height: '100%',
            width: '100%',
            objectFit: 'contain',
            display: 'flex',
            alignItems: 'stretch',
            borderRadius: '6px',
            overflow: 'hidden',
          }}
        />
      )}
      <SecondaryLoadingButton sx={{ padding: '0.5rem 0', border: 0 }} onClick={handleInputClick} loading={videoLoading}>
        <UploadIcon sx={{ margin: '0 0.5rem 0 0', color: 'primary.main' }} />
        {buttonLabel}
      </SecondaryLoadingButton>
    </div>
    <input
      type="file"
      accept=".mp4,.webm,.mov"
      ref={videoFileInputRef}
      onChange={handleVideo}
      style={{ display: 'none' }}
    />
  </div>
);

export default VideoInput;
